import React, {Component} from 'react';
import api from '../../utils/api';
import MarketShareCluster from '../analisis/marketsharecluster';
import Sensibility from '../analisis/sensibility';

export default class ClusterStrategyFull extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            prodTitles:{},
            prodShortTitles: {},
            prodMapping : {},
            activeTab: 0,
            stations: []
        }
    }

    componentWillMount(){
        let _self = this;
        api.get("filters/products/").then((out) => {
            let pTitles = {};
            let pShortTitles = {};
            let pMapping = {};
            let i = 1;

            out.data.forEach(e => {
                pTitles[i] = e.name;
                pShortTitles[i] = e.short_name;
                pMapping[e.name] = e.short_name;
                i++;
            });

            api.get('clusters/id/' + _self.props.data.id).then(resp => {
              _self.setState({stations: resp.data.stations ,prodTitle : pTitles, prodShortTitles : pShortTitles, prodMapping : pMapping});
            });
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let _self = this;
        let _state = _self.state;
        _state.data = nextProps.data;
        _self.setState(_state);
    }

    render() {
        let _self = this;
        let data = _self.props.data;
        let i = 0;

        return <div className="row clusterStrategy">
            <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className="marketShare">
                            <table className='c-table'>
                                <thead>
                                <tr>
                                    <td>&nbsp;</td>
                                    {_self.state.prodShortTitles && Object.keys(_self.state.prodShortTitles).map(key =>
                                        <td key={key}>{_self.state.prodShortTitles[key]}</td>
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {_self.state.prodMapping && data && data.prices && Object.keys(data.prices).map(k => {
                                    i++;
                                    return <tr key={i}>
                                        <td>{k}</td>
                                        {Object.keys(data.prices[k]).map(field => {
                                            if(k === "Nuevo Precio Referencia") {
                                              return <td key={k+field+i}>
                                                    <input name={_self.state.prodMapping[field]} type="number"
                                                           value={data.prices[k][field]}
                                                           onChange={ev => {
                                                               data.prices[k][field] = ev.target.value;
                                                               _self.props.checkNewRefPrice(k, data);
                                                           }}/>
                                                </td>
                                            } else if(k === "Nuevo Diferencial (%)" || k === "Aumento (%)") {
                                                return <td key={k+field+i}>
                                                    <input name={_self.state.prodMapping[field]} type="number"
                                                           value={data.prices[k][field]}
                                                           min="0" max="100"
                                                           onChange={ev => {
                                                               data.prices[k][field] = ev.target.value;
                                                               if (data.prices[k][field] < 0) data.prices[k][field] = 0;
                                                               if (data.prices[k][field] > 100) data.prices[k][field] = 100;
                                                               _self.props.checkNewRefPrice(k, data);
                                                           }}/>
                                                </td>
                                            } else if(k === "Aumento Hipotético PM (%)"){
                                                return <td key={k+field+i}>
                                                    <input name={_self.state.prodMapping[field]} type="number"
                                                           min="0" max="100"
                                                           value={data.prices[k][field]}
                                                           onChange={ev => {
                                                               data.prices[k][field] = ev.target.value;
                                                               if (data.prices[k][field] < 0) data.prices[k][field] = 0;
                                                               if (data.prices[k][field] > 100) data.prices[k][field] = 100;
                                                                _self.props.checkIncreasePrice(k, data);
                                                           }}/>
                                                </td>
                                            } else {
                                                if(data.prices[k][field]) {
                                                    return <td key={k+field+i}><input readOnly="readonly" name={_self.state.prodMapping[field]} type="number"
                                                           value={data.prices[k][field]}
                                                        /></td>
                                                }
                                                else{
                                                    return <td key={k+field+i}><input readOnly="readonly" name={_self.state.prodMapping[field]} type="number" value="0.00" /></td>
                                                }
                                            }
                                        })}
                                    </tr>
                                })}
                                </tbody>
                            </table>
                            <div className="sensibility-graph">
                                <div className="c-tabs">
                                  <div className="c-tabs-header">
                                     <div onClick={() => { this.setState({activeTab: 0}) }} className={"c-tabs-header-link" + (this.state.activeTab === 0 ? ' active' : '')}>Sensibilidad Precio - Demanda</div>
                                     <div onClick={() => { this.setState({activeTab: 1}) }} className={"c-tabs-header-link" + (this.state.activeTab === 1 ? ' active' : '')}>Market Share</div>
                                     <div onClick={() => { this.setState({activeTab: 2}) }} className={"c-tabs-header-link" + (this.state.activeTab === 2 ? ' active' : '')}>Listado Bocas</div>
                                   </div>
                                   <div className="c-tabs-content">
                                    <div className={"c-tabs-content-item" + (this.state.activeTab === 0 ? ' active' : '')}>
                                      <Sensibility level="CLUSTER" data={data} />
                                    </div>  
                                    <div className={"c-tabs-content-item" + (this.state.activeTab === 1 ? ' active' : '')}>
                                      <MarketShareCluster static id={data.id} level="CLUSTER" />
                                    </div>
                                    <div className={"c-tabs-content-item" + (this.state.activeTab === 2 ? ' active' : '')}>
                                      <div className="row">
                                        <div className="row"></div>
                                        <div className="row">
                                          <div className="col s12">
                                            <div className="row">
                                              <div className="pumps">
                                                <ul className='pumps-list'>
                                                  {_self.state.stations.map(station => {
                                                    return <li key={station.id}>
                                                      <i className={"fas fa-map-marker-alt " + station.brand.name.toLowerCase()} />
                                                      <b>{station.brand.name.toLowerCase().includes('shell') ? ('Shell ' + station.global_code + ' (' + station.inscription_number + ')') : station.brand.name + " " + station.inscription_number}</b>
                                                      <span>{station.address}</span>
                                                    </li>
                                                  })}
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/simulador/clusterstrategy-full.js